import Youtubeplayer from 'picnic/youtubeplayer/views/Youtubeplayer';

class View extends Youtubeplayer {

	async play() {
		super.play();

		// Start video after rendering on mobile devices
		if (!this._hasPlayer()) {
			// Wait for the playVideo callback
			const
				waitForCondition = () => {
					const waitFor = (result) => {
						if (result) {
							return result;
						}
						return new Promise((resolve) => setTimeout(() => {
							resolve();
						}, 100))
						.then(() => Promise.resolve(this._player?.playVideo))
						.then((res) => waitFor(res));
					};
					return waitFor();
				},
				hasPlayVideo = await waitForCondition()
			;

			// Play
			hasPlayVideo && this._player.playVideo();
		}
	}

	_onPlayerRendered() {
		super._onPlayerRendered();
		this._showDisplay();
	}


}

export default View;
